import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import './AmplifyConfigure';
import Router from './Router';

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router />
    </QueryClientProvider>
  );
};

export default App;
